import './SingleValueGrid.css';
export var gridRows = '_1mx9zjb0-3-8-0';